(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["origo-mega-header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('toggle', (event) => {
    const detail = event.target;
    if (!(detail instanceof HTMLDetailsElement) || !detail.matches('.origo-header__nav-item') || !detail.open) return;
    detail.closest('.origo-header')?.querySelectorAll('.origo-header__nav-item[open]').forEach((item) => {
      if (item !== detail) item.open = false;
    });
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.origo-header details[open]').forEach((item) => { item.open = false; });
  });

  } catch(e) { console.error(e); }
})();
})();
